import { Box } from "@mui/material";
import { Charts } from "../../../../components";
import { useAppSelector } from "../../../../store/hooks";
import { selectExtension } from "../../../../features/extension/extension.selector";

const ChartsContainer = () => {
  const { isExtension } = useAppSelector(selectExtension);

  return (
    <Box>
      <Charts hideOpenNew={isExtension} />
    </Box>
  );
};

export default ChartsContainer;
